import React, { useContext, useEffect, useState } from 'react'
import { ApiGetCall, ApiGetCDNData } from '../JS/Connector';
import { HideLoder, ShowLoder, formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY, formatDecimal, origin, unescapeHtml } from '../JS/Common';
import { useNavigate } from 'react-router-dom';
import Tab from './Tab';
import Popup from './Popup';
import ImagesPopup from './ImagesPopup';
import { useSelector } from 'react-redux';
import useConfig from '../Hooks/useConfig';
function TicketDetailsPopup(props) {
    const { organization_part, show_ticket_status_notes } = useConfig();
    const StateData = useSelector((state) => state.authData);
    const [TicketTab, setTicketTab] = useState({
        TicketHistoryTab: "",
        PartHistoryTab: "",
        TicketDetailsTab: 'active'
    });
    const [TicketHistoryDetails, setTicketHistoryDetails] = useState([]);
    const [ticketDetails, setticketDetails] = useState('')
    const [AttachPartHistory, setAttachPartHistory] = useState([])
    const [loading, setLoading] = useState(false);
    const [batchNames, setBatchNames] = useState({
        names: '',
        status: ''
    })
    const [RepairLog, setRepairLog] = useState([])
    const [imageUrls, setImageUrls] = useState([]);
    const [showImagesModal, setShowImagesModal] = useState({
        show: false,
        activeIndex: 0,
        zoomInOut: false,
    });
    const navigate = useNavigate();
    useEffect(() => {
        if (ticketDetails?.ticket_img?.length) {
            Promise.all(
                ticketDetails.ticket_img.map((picture) =>
                    ApiGetCDNData("/" + picture.img, StateData?.Schoolnumber).then((blob) =>
                        URL.createObjectURL(blob)
                    )
                )
            ).then((urls) => {
                setImageUrls(urls);
            });
        }
    }, [ticketDetails]);
    useEffect(() => {
        setLoading(true);
        ApiGetCall(`/tickets/by-id?ticketId=${props.ticketid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                const responseRs = JSON.parse(result)
                setLoading(false);
                var sugData = responseRs.ticket;
                if (responseRs.response == "success") {
                    setticketDetails(sugData);
                    setTicketHistoryDetails(sugData.ticket_history);
                    setAttachPartHistory(sugData.ticket_attachments);
                    setBatchNames({ ...batchNames, names: sugData?.incoming_batch_name?.split(', '), status: sugData?.incoming_batch_status });
                    setRepairLog(sugData?.ticket_repair_log[0]?.repaired_item);
                }
            }
        });
    }, []);
    function handleTabClick(tabType) {
        if (tabType == "ticketdetails") {
            setTicketTab({ ...TicketTab, TicketDetailsTab: "active", TicketHistoryTab: "", PartHistoryTab: "" });
        } else if (tabType == "tickethistory") {
            setTicketTab({ ...TicketTab, TicketDetailsTab: "", TicketHistoryTab: "active", PartHistoryTab: "" });
        } else if (tabType == "parthistory") {
            setTicketTab({ ...TicketTab, TicketDetailsTab: "", TicketHistoryTab: "", PartHistoryTab: "active" });
        }
    }

    function isWarrantyColor(itemPart) {
        if (itemPart.is_adhoc_checkbox == 1 && itemPart.is_warranty_checkbox == 1) return false;
        if (itemPart.is_warranty_checkbox == 1) return true;
        if (itemPart.part_covered_by == 1 && itemPart.is_adhoc_checkbox != 1) return true;
        return false;
    }
    const modalbody = (
        <>
            <ul className="nav nav-tabs">
                <Tab isActive={TicketTab.TicketDetailsTab == 'active'}
                    label="Ticket Details" onClick={() => handleTabClick('ticketdetails')} col={'col-md-3'} />
                <Tab isActive={TicketTab.TicketHistoryTab == 'active'}
                    label="Ticket History" onClick={() => handleTabClick('tickethistory')} col={'col-md-3'} />
                <Tab isActive={TicketTab.PartHistoryTab == 'active'}
                    label="Parts History" onClick={() => handleTabClick('parthistory')} col={'col-md-3'} />
            </ul>
            {TicketTab.TicketDetailsTab == 'active' && (
                <div className="mb-3 mt-3">
                    <div className="row px-4">
                        {ticketDetails && (
                            <>
                                {props.BatchNmFlag == 1 && ticketDetails.billing_batch_flag == true && (
                                    <div className=" p-1 pe-0 row">
                                        <div className="col fw-600">Outgoing Batch Name : </div>
                                        <div className="col"> {ticketDetails.billing_batch_name}</div>
                                    </div>
                                )}
                                {props.BatchNmFlag == 1 && ticketDetails.incoming_batch_flag == true && (
                                    <div className=" p-1 pe-0 row">
                                        <div className="col fw-600">Incoming Batch Name : </div>
                                        <div className="col"> <u>
                                            {batchNames?.names.map((item, index) => (
                                                <span key={index} className='cursor-pointer' onClick={(e) => navigate('/incoming-batches/' + item, { state: { IncomingBatchStatus: batchNames.status } })}>
                                                    {item}
                                                    {index !== batchNames?.names.length - 1 ? ', ' : ''}
                                                </span>
                                            ))}
                                        </u></div>
                                    </div>
                                )}
                                <div className=" p-1 pe-0 row">
                                    <div className="col fw-600">Serial # : </div>
                                    <div className="col wordwrap"> {ticketDetails.inventory_management.serial_number}</div>
                                </div>
                                <div className=" p-1 pe-0 row">
                                    <div className="col fw-600">Ticket # : </div>
                                    <div className="col"> {ticketDetails.ticket_num}</div>
                                </div>
                                <div className=" p-1 pe-0 row">
                                    <div className="col fw-600">User : </div>
                                    <div className="col"> {(ticketDetails?.student?.device_user_first_name || '-') + ' ' + (ticketDetails?.student?.device_user_middle_name || '') + ' ' + (ticketDetails?.student?.device_user_last_name || '')}</div>
                                </div>
                                <div className=" p-1 pe-0 row">
                                    <div className="col fw-600">Created Date : </div>
                                    <div className="col"> {ticketDetails.created_at ? formatDateToUsaMMDDYYYY(ticketDetails.created_at) : '-'}</div>
                                </div>
                                <div className=" p-1 pe-0 row">
                                    <div className="col fw-600">Created By : </div>
                                    <div className="col"> {ticketDetails.ticket_created_by}</div>
                                </div>
                                <div className=" p-1 pe-0 row">
                                    <div className="col fw-600">Building : </div>
                                    <div className="col text-break"> {ticketDetails?.inventory_management?.building_name?.name || '-'}</div>
                                </div>
                                <div className=" p-1 pe-0 row">
                                    <div className="col fw-600">Return Location : </div>
                                    <div className="col"> {ticketDetails.return_location_name || '-'}</div>
                                </div>
                                <div className=" p-1 pe-0 row">
                                    <div className="col fw-600">Issue : </div>
                                    <div className="col" style={{ display: "inline" }}>
                                        {ticketDetails.ticket_issues.map((item) => item.issue_name).join(", ")}
                                    </div>
                                </div>
                                <div className=" p-1 pe-0 row">
                                    <div className="col fw-600">Notes : </div>
                                    <div className="col" style={{ display: "inline" }}>
                                        {unescapeHtml(ticketDetails.notes) || "-"}
                                    </div>
                                </div>
                                <div className=" p-1 pe-0 row">
                                    <div className="col fw-600">Repaired Notes : </div>
                                    <div className="col" style={{ display: "inline" }}>
                                        {RepairLog || '-'}
                                    </div>
                                </div>
                                <div className=" p-1 pe-0 row">
                                    <div className="col fw-600">Images : </div>
                                    <div className="col" style={{ display: "inline" }}>
                                        {imageUrls.length > 0 ? (
                                            imageUrls.map((url, index) => (
                                                <img
                                                    key={index}
                                                    className="px-2"
                                                    src={url}
                                                    alt={`Image ${index}`}
                                                    style={{ height: "50px", cursor: "pointer" }}
                                                    onClick={() => setShowImagesModal({ ...showImagesModal, show: true, activeIndex: index })}
                                                />
                                            ))
                                        ) : (
                                            <>-</>
                                        )}
                                    </div>
                                </div>
                                <div className=" p-1 pe-0 row">
                                    <div className="col fw-600">Status : </div>
                                    <div className="col" style={{ color: "var(--primary-color)" }}>
                                        {ticketDetails.status}
                                    </div>
                                </div>
                                {Object.entries(ticketDetails?.custom_data || {}).map(([key, value]) => (
                                    <div className="p-1 pe-0 row" key={key}>
                                        <div className="col fw-600">{key?.replace(/_/g, ' ')?.replace(/\b\w/g, c => c.toUpperCase())} :</div>
                                        <div className="col">
                                            {value}
                                        </div>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                </div>
            )}
            {TicketTab.TicketHistoryTab == 'active' && (
                <div className=" mt-3">
                    <div className="row px-4 scrollbar-css">
                        {TicketHistoryDetails.length != 0 ?
                            <>
                                {TicketHistoryDetails.map((item, i) => {
                                    var returData = <>
                                        <div className="col-12 py-1" key={i}>
                                            On <b>{item.date ? formatDateToMMDDYYYY(item.date) : '-'}</b>,{" "}
                                            {item.updateby} has changed the
                                            ticket status from{" "}
                                            {item.to} to{" "}
                                            {item.from}
                                        </div>
                                        {show_ticket_status_notes && (
                                            <>
                                                <div className='col-12 py-1'>
                                                    <strong>Note: </strong>
                                                    {item.note || "-"}
                                                </div>
                                                <img src="/images/HorizontalLine.svg" className="img-fluid w-100" />
                                            </>
                                        )}
                                    </>
                                    return returData;
                                })}
                            </>
                            :
                            <div className="col-12 text-center">
                                <label>No Record Found</label>
                            </div>
                        }
                    </div>
                </div>
            )}
            {TicketTab.PartHistoryTab == 'active' && (
                <>
                    {AttachPartHistory.length != 0 ?
                        <>
                            {
                                AttachPartHistory.map((item, i) => {
                                    var returData;
                                    returData = (
                                        <div className="row px-4 mt-2" key={i}>
                                            <div className="col-12 p-1 pe-0 row mt-1">
                                                <div className="col-md-3 fw-600">Part Name : </div>
                                                <div className={`${isWarrantyColor(item) ? 'highlight-part' : ''} col-md-9`}> {item.part_name + ' ' + '(' + (item.part_flag == 1 ? 'Master Part' : organization_part) + ')'}</div>
                                            </div>
                                            <div className="col-12 p-1 pe-0 row mt-1">
                                                <div className="col-md-3 fw-600">Building : </div>
                                                <div className="col-md-9 text-break">  {item.building ? item.building?.name : '-'}</div>
                                            </div>
                                            <div className="col-12 p-1 pe-0 row mt-1">
                                                <div className="col-md-3 fw-600">Created By : </div>
                                                <div className="col-md-9"> {item.user_name}</div>
                                            </div>
                                            <div className="col-12 p-1 pe-0 row mt-1">
                                                <div className="col-md-3 fw-600"> Price : </div>
                                                <div className="col-md-9">${formatDecimal(item.part_price) || '0'}</div>
                                            </div>
                                            <div className="col-12 p-1 pe-0 row mt-1">
                                                <div className="col-md-3 fw-600">Notes : </div>
                                                <div className="col-md-9"> {item.part_note || '-'}</div>
                                            </div>
                                            <img src="/images/HorizontalLine.svg" className="img-fluid w-100 mt-2 ps-0" />
                                        </div>
                                    );
                                    return returData;
                                })
                            }
                        </>
                        :
                        <div className="col-12 pt-3 text-center">
                            <label>No Record Found</label>
                        </div>
                    }
                </>
            )}
        </>
    )
    return (
        <>
            {loading ? <ShowLoder /> : <HideLoder />}
            <Popup isshow={props.isShow} size={"lg"} title={"Ticket Details"}
                closePopup={props.ClosePopup}
                modalBody={modalbody} visibleSaveBtn={false} isBlur={showImagesModal.show} />
            <ImagesPopup
                AllImages={imageUrls}
                isShow={showImagesModal.show}
                closePopup={() => setShowImagesModal({ ...showImagesModal, show: false, activeIndex: 0, zoomInOut: false })}
                title={"Preview Images"}
                size={"xl"}
                activeIndex={showImagesModal.activeIndex}
                handleActiveIndex={(selectedIndex) => setShowImagesModal((prev) => ({ ...prev, activeIndex: selectedIndex, zoomInOut: false }))}
                zoomInOut={showImagesModal.zoomInOut}
                handleZoomInOut={() => setShowImagesModal({ ...showImagesModal, zoomInOut: !showImagesModal.zoomInOut })}
            />
        </>
    )
}
export default TicketDetailsPopup